import Validator from "./Validator";
import { User } from "@/types";

const PasswordMatching = ({ password, repeatPassword }: Pick<User, "password" | "repeatPassword">) => {
  return (
    <Validator
      title="Las contraseñas deben ser iguales:"
      validations={[
        {
          label: "Ser iguales",
          isValid: password === repeatPassword,
        },
      ]}
    />
  );
};
export default PasswordMatching;
